import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';

@Component({
  selector: 'timepicker',
  templateUrl: './timepicker.component.html',
  styleUrls: ['./timepicker.component.less']
})
export class TimepickerComponent implements OnInit {

	time:any;
	@Input() label:string;
  	@Input() required:string;
  	@Input() type:string;
	@Output() timeChange = new EventEmitter();

  	constructor() { 
		this.currentTime();
	  }

  	ngOnInit() {
  		this.currentTime();
  		this.onSelectTime(this.time);
	  }
	  
	  currentTime(){
		var d = new Date();
    	var h = d.getHours();
    	var m = d.getMinutes();
    	var s = d.getSeconds();
  		this.time = {hour: h, minute: m};
	  }

	onSelectTime(t){
		if(!this.type){
    		var type = 'time';
    	}else{
    		var type = this.type+'Time';
    	}
    	if (!t){
    		var d = new Date();
    		var dh = this.addZero(d.getHours());
    		var dm = this.addZero(d.getMinutes());
    		var time = dh+':'+dm;
    	}else{
    		var h = this.addZero(t.hour);
    		var m = this.addZero(t.minute);
    		var time = h+':'+m;
    	}
		this.timeChange.emit({time,type});
	}

	addZero(i) {
	    if (i < 10) {
	        i = "0" + i;
	    }
	    return i;
	}

}



// WEBPACK FOOTER //
// /Users/matthewspringbett/sites/worryandpeace/valhalla/src/app/timepicker/timepicker.component.ts